import { find, startCase, isPlainObject, cloneDeep } from 'lodash';
import { singularize } from './case';
import { requireModels } from './require';

export function modelNameFromEntityName(entityName) {
  entityName = entityName.toLowerCase();

  return startCase(singularize(entityName)).replace(/\s/g, '');
}

export function modelName(model) {
  return modelNameFromEntityName(model.entity);
}

export function modelClassFromEntityName(entityName) {
  return modelClassFromModelName(modelNameFromEntityName(entityName));
}

export function modelClassFromModelName(modelName) {
  const modelConfigs = requireModels();
  const config = find(modelConfigs, (pair) => pair[0] === modelName);

  if (!config) return;

  return config[1];
}

export function getWithDefaultValues(entityRecord) {
  const fields = entityRecord.$fields();
  const values = {};

  Object.keys(fields).forEach((key) => {
    // Avoid saving internal keys.
    if (key[0] === '$') {
      return;
    }

    const field = fields[key];

    // HACK: There doesn't seem to be another way to detect non-relations.
    const isAttr = field.hasOwnProperty('mutator');
    if (!isAttr) {
      return;
    }

    // Prefer the real value over a default value.
    if (entityRecord.hasOwnProperty(key)) {
      values[key] = isPlainObject(entityRecord[key])
        ? cloneDeep(entityRecord[key])
        : entityRecord[key];

      return;
    }

    const value =
      typeof field.value === 'function' ? field.value() : field.value;

    values[key] = value;
  });

  return values;
}
